import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import './kyc.css';
import moment from "moment";
import { store } from "../../redux/store";
import { setPersonalInfo, setROId, setROResponse, setSaveData } from "../../redux/retailer-kyc-details/retailer-kyc-details.action";
import { Link } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import HeaderCommon from './../HeaderComponent/HeadeCommon';
import Menu from "../MenuComponent/Menu";
const httpClient = axios.create();

class AddBusinessDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            shopName: '',
            address: '',
            address2: '',
            city: '',
            pinCode: '',
            pinCodeErr: '',
            businesstypes: [
                { value: "Select", label: "Select" },
                { value: "INDIVIDUAL", label: "INDIVIDUAL" },
                { value: "PARTNERSHIP", label: "PARTNERSHIP" },
                { value: "PVT_LTD", label: "PVT LTD" },
                { value: "SOLE_PROPRIETOR", label: "SOLE PROPRIETOR" },
            ],

            addressTypes: [
                { value: "Select", label: "Select" },
                { value: "RESIDENTIAL", label: "RESIDENTIAL" },
                { value: "SHOP", label: "SHOP" },
                { value: "OFFICE", label: "OFFICE" },
            ],
            addressType: '',
            addressTypeOnLoad: '',
            addressTypeErrMsg: '',

            states: [
                { value: "Select", label: "Select" },
                { value: "Andhra Pradesh", label: "Andhra Pradesh" },
                { value: "Andaman and Nicobar Islands", label: "Andaman and Nicobar Islands" },
                { value: "Arunachal Pradesh", label: "Arunachal Pradesh" },
                { value: "Assam", label: "Assam" },
                { value: "Bihar", label: "Bihar" },
                { value: "Chandigarh", label: "Chandigarh" },
                { value: "Chhatisgarh", label: "Chhatisgarh" },
                { value: "Dadra and Nagar Haveli", label: "Dadra and Nagar Haveli" },
                { value: "Daman and Diu", label: "Daman and Diu" },
                { value: "Delhi NCR", label: "Delhi NCR" },
                { value: "Goa", label: "Goa" },
                { value: "Gujarat", label: "Gujarat" },
                { value: "Haryana", label: "Haryana" },
                { value: "Himachal Pradesh", label: "Himachal Pradesh" },
                { value: "Jammu & Kashmir", label: "Jammu & Kashmir" },
                { value: "Jharkhand", label: "Jharkhand" },
                { value: "Karnataka", label: "Karnataka" },
                { value: "Kerala", label: "Kerala" },
                { value: "Ladakh", label: "Ladakh" },
                { value: "Lakshadweep", label: "Lakshadweep" },
                { value: "Madhya Pradesh", label: "Madhya Pradesh" },
                { value: "Maharashtra", label: "Maharashtra" },
                { value: "Manipur", label: "Manipur" },
                { value: "Mizoram", label: "Mizoram" },
                { value: "Nagaland", label: "Nagaland" },
                { value: "Odisha", label: "Odisha" },
                { value: "Puducherry", label: "Puducherry" },
                { value: "Punjab", label: "Punjab" },
                { value: "Rajasthan", label: "Rajasthan" },
                { value: "Sikkim", label: "Sikkim" },
                { value: "Tamilnadu", label: "Tamilnadu" },
                { value: "Telangana", label: "Telangana" },
                { value: "Tripura", label: "Tripura" },
                { value: "Uttar Pradesh", label: "Uttar Pradesh" },
                { value: "Uttarakhand", label: "Uttarakhand" },
                { value: "West Bengal", label: "West Bengal" },
            ],
            businessType: '',
            businessTypeOnLoad: '',
            businessTypeErrMsg: '',
            stateName: '',
            stateOnLoad: '',
            stateErrMsg: '',
            shopImageUrl: '',
            personalInfo: null,
            saveDataErr: '',
            progress: ''
        }
    }

    componentDidMount() {
        this.getSessionDetails();
    }

    getSessionDetails = () => {
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.i
        };

        httpClient.get('/api/v1/retailer/onboard/session/' + this.props.registerRetailerResponse.sessionId
            , { headers }
        ).then((response) => {
            console.log('session Id retailer response' + JSON.stringify(response.data));

            if (response.data != null) {
                if (response.data.shopDetails != null) {
                    if (response.data.shopDetails.address != null) {
                        this.setState({
                            shopName: response.data.shopDetails.name,
                            address: response.data.shopDetails.address.add1,
                            address2: response.data.shopDetails.address.add2,
                            city: response.data.shopDetails.address.city,
                            district: response.data.shopDetails.address.district,
                            stateOnLoad: response.data.shopDetails.address.state,
                            stateName: response.data.shopDetails.address.state,
                            pinCode: response.data.shopDetails.address.pincode,
                            addressType: response.data.shopDetails.address.type,
                            addressTypeOnLoad: response.data.shopDetails.address.type,
                            businessTypeOnLoad: response.data.shopDetails.type,
                            businessType: response.data.shopDetails.type,
                            shopImageUrl: response.data.shopDetails.shopPic
                        })


                    }
                    if (response.data.shopDetails.shopPic != null) {
                        this.setState({
                            shopImageUploadMsg: 'Successfully Uploaded shop image'
                        })
                    }
                }

                if (response.data.personalInfo != null) {
                    this.setState({
                        personalInfo: response.data.personalInfo
                    })
                }
            }
        }).catch(error => {

    

        });
    }
    componentWillUnmount() {
    }

    enterShopName = (event) => {
        this.setState({
            shopName: event.target.value
        })
    }
    enterAddress = (event) => {
        this.setState({
            address: event.target.value
        })
    }
    enterAddress2 = (event) => {
        this.setState({
            address2: event.target.value
        })
    }
    enterCity = (event) => {
        this.setState({
            city: event.target.value
        })
    }
    enterPinCode = (event) => {
        this.setState({
            pinCodeErr: '',
            pinCode: event.target.value
        })
    }

    typeSelect = (event) => {
        if (event.target.value == 'Select') {

            this.setState({
                businessTypeErrMsg: 'Please select a business type'
            })
        } else {
            this.setState({
                businessTypeErrMsg: '',
                businessType: event.target.value
            })
        }
    }

    addressTypeSelect = (event) => {
        if (event.target.value == 'Select') {
            this.setState({
                addressTypeErrMsg: 'Please select an address type'
            })
        } else {
            this.setState({
                addressTypeErrMsg: '',
                addressType: event.target.value
            })
        }
    }
    showAddressTypeSection = () => {
        this.setState({
            addressType: '',
            addressTypeOnLoad: ''
        })
    }
    showBusinessTypeSection = () => {
        this.setState({
            businessType: '',
            businessTypeOnLoad: ''
        })
    }
    stateSelect = (event) => {
        if (event.target.value == 'Select') {

            this.setState({
                stateErrMsg: 'Please select a state'
            })
        } else {
            this.setState({
                stateErrMsg: '',
                stateName: event.target.value
            })
        }
    }

    showStateSection = () => {
        this.setState({
            stateName: '',
            stateOnLoad: ''
        })
    }


    dropHandler = (ev) => {
        console.log('File(s) dropped');
        ev.preventDefault();
        if (ev.dataTransfer.items) {
            for (var i = 0; i < ev.dataTransfer.items.length; i++) {
                if (ev.dataTransfer.items[i].kind === 'file') {
                    var file = ev.dataTransfer.items[i].getAsFile();
                    console.log('... file[' + i + '].name = ' + file.name);
                }
            }
        } else {
            for (var i = 0; i < ev.dataTransfer.files.length; i++) {
                console.log('... file[' + i + '].name = ' + ev.dataTransfer.files[i].name);
            }
        }
    }
    dragOverHandler = (ev) => {
        console.log('File(s) in drop zone');
        ev.preventDefault();
    }

    uploadDoc = (event, type) => {
        if (type == 'shopImage') {
            this.setState({
                shopImageUploaErrdMsg: '',
                shopImageUploadMsg: '',
            })
        }

        if (event != null) {
            if (event.target != null) {
                console.log('event.....' + JSON.stringify(event.target.files));
                console.log('event.....' + JSON.stringify(event.target.files[0]));
                if (event.target.files[0].name.includes(".jpg") || event.target.files[0].name.includes(".gif")
                    || event.target.files[0].name.includes(".png")
                    || event.target.files[0].name.includes(".pdf")) {
                    // if (parseInt(event.target.files[0].size / 1000) < 10 * 1024) {

                    if (event.target.files[0] != null) {

                        console.log('event.target.files[0]' + URL.createObjectURL(event.target.files[0]));
                        this.setState({
                            selectedFile: URL.createObjectURL(event.target.files[0])
                        });
                        this.onFileUpload(event.target.files[0], type);
                    }
                    // } else {
                    //     console.log("file size is greater than 10 MB");
                    //     this.setState({
                    //         uploadErrorMessage: 'file size is greater than 10 MB'
                    //     })
                    // }
                } else {
                    console.log("file type is::" + event.target.files[0].type + " only .jpg,.png, .gif,.pdf supported");
                    if (type == 'shopImage') {
                        this.setState({
                            shopImageUploaErrdMsg: "file type is::" + event.target.files[0].type + " only .jpg,.png, .gif,.pdf supported"
                        })
                    }
                }
            }
        }
    }


    onFileUpload = (value, typeVal) => {
        var fileName = uuidv4() + value.name;
        this.setState({
            progress: 0
        })
        console.log('file name::' + value.name);

        const formData = new FormData();
        formData.append(
            "doc", value
        );
        formData.append(
            "name", fileName
        );
        formData.append(
            "type", value.type
        );

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id
            , 'role': this.props.clientRole
        }
        fetch('/api/v1/document', {
            method: 'post',
            body: formData,
            headers: headers
        }).then(res => res.json())
            .then(data => {
                if (data.id != null && data.id != undefined && data.id != '') {
                    this.setState({
                        progress: 100,
                        imageUrl: fileName,
                        uploadedDocType: typeVal,
                        uploadedMsg: typeVal + ' uploaded successfully'
                    })
                    if (typeVal == 'shopImage') {
                        this.setState({
                            shopImageUrl: data.href,
                            shopImageUploadMsg: 'Successfully Uploaded shop image'
                        })
                    }
                } else {
                    this.setState({
                        shopImageUploaErrdMsg: "Something went wrong!"
                    })
                }
            }).catch(errorx => {
                if (typeVal == 'shopImage') {
                    this.setState({
                        shopImageUploaErrdMsg: "Something went wrong!"
                    })
                }
                console.log('file upload error..' + errorx);
            });
    }

    removeImage = (event) => {
        console.log('removeImage');
        this.setState({
            removeStatus: true,
            selectedFile: null
        })
    }

    reassignVal = () => {

        if (this.state.addressTypeOnLoad != '') {
            this.setState({
                addressType: this.state.addressTypeOnLoad
            })
        }
        if (this.state.businessTypeOnLoad != '') {
            this.setState({
                businessType: this.state.businessTypeOnLoad
            })
        }
        if (this.state.stateOnLoad != '') {
            this.setState({
                stateName: this.state.stateOnLoad
            })
        }
    }

    saveAndFinalizeValidation = () => {

        //re-assigning values if exist

        if (this.state.addressTypeOnLoad != '') {
            this.setState({
                addressType: this.state.addressTypeOnLoad
            })
        }
        if (this.state.businessTypeOnLoad != '') {
            this.setState({
                businessType: this.state.businessTypeOnLoad
            })
        }
        if (this.state.stateOnLoad != '') {
            this.setState({
                stateName: this.state.stateOnLoad
            })
        }
        var stateValidation = false;
        var businessTypeValidation = false;
        var addressTypeValidation = false;
        var shopImageValidation = false;
        var pincodeValidation = false;

        if (this.state.stateName != '' &&
            this.state.stateName != 'Select') {
            stateValidation = true;
        } else {
            this.setState({
                stateErrMsg: 'Please select a state'
            })
        }
        if (this.state.businessType != '' &&
            this.state.businessType != 'Select') {
            businessTypeValidation = true;
        } else {
            this.setState({
                businessTypeErrMsg: 'Please select a business Type'
            })
        }

        if (this.state.addressType != '' &&
            this.state.addressType != 'Select') {

            addressTypeValidation = true;
        } else {

            this.setState({
                addressTypeErrMsg: 'Please select an address Type'
            })
        }

        if (this.state.shopImageUrl != '') {
            shopImageValidation = true;
        } else {
            this.setState({
                shopImageUploaErrdMsg: 'Upload Shop Image'
            })
        }

        if (this.state.pinCode != '' && this.state.pinCode.length == 6) {
            pincodeValidation = true;
        } else {
            this.setState({
                pinCodeErr: 'Please select Valid Pincode'
            })
        }

        if (stateValidation == true
            && businessTypeValidation == true
            && shopImageValidation == true
            && pincodeValidation == true
            && addressTypeValidation == true
        ) {
            return true;
        } else {
            return false;
        }



    }

    saveAndFinalize = (event) => {
        event.preventDefault();


        var stateValidation = false;
        var businessTypeValidation = false;
        var addressTypeValidation = false;
        var shopImageValidation = false;
        var pincodeValidation = false;

        if (this.state.addressTypeOnLoad != '') {
            this.setState({
                addressType: this.state.addressTypeOnLoad
            })
            addressTypeValidation = true;
        } else {
            if (this.state.addressType != '' &&
                this.state.addressType != 'Select') {
                addressTypeValidation = true;
            } else {
                this.setState({
                    addressTypeErrMsg: 'Please select an address Type'
                })
            }
        }

        if (this.state.businessTypeOnLoad != '') {
            this.setState({
                businessType: this.state.businessTypeOnLoad
            })
            businessTypeValidation = true;
        } else {
            if (this.state.businessType != '' &&
                this.state.businessType != 'Select') {
                businessTypeValidation = true;
            } else {
                this.setState({
                    businessTypeErrMsg: 'Please select a business Type'
                })
            }
        }


        if (this.state.stateOnLoad != '') {
            this.setState({
                stateName: this.state.stateOnLoad
            })
            stateValidation = true;
        } else {
            if (this.state.stateName != '' &&
                this.state.stateName != 'Select') {
                stateValidation = true;
            } else {
                this.setState({
                    stateErrMsg: 'Please select a state'
                })
            }
        }


        if (this.state.shopImageUrl != '') {
            shopImageValidation = true;
        } else {
            this.setState({
                shopImageUploaErrdMsg: 'Upload Shop Image'
            })
        }

        if (this.state.pinCode != '' && this.state.pinCode.length == 6) {
            pincodeValidation = true;
        } else {
            this.setState({
                pinCodeErr: 'Please select Valid Pincode'
            })
        }

        if (stateValidation == true
            && businessTypeValidation == true
            && shopImageValidation == true
            && pincodeValidation == true
            && addressTypeValidation == true
        ) {
            this.setState({
                progress: 'loading'
            })

            var saveDataUrl = '/api/v1/retailer/onboard/session/save';
            var header = {
                msgType: "CREATE_ORDER",
                service: "KYC",
                src: "register-retailer",
                dst: "register-retailer",
                channel: "API",
                requesterId: this.props.clientRequesterId,
                requestId: uuidv4(),
                traceId: uuidv4(),
            }
            var personalInfo = this.state.personalInfo;

            var address = {
                fullAddress: this.state.address + ' ' + this.state.address2,
                add1: this.state.address,
                add2: this.state.address2,
                city: this.state.city,
                district: '',
                state: this.state.stateName,
                pincode: this.state.pinCode,
                location: this.props.deviceInfo.location,
                type: this.state.addressType
            }
            var personalInfo1 = {
                gender: personalInfo.gender,
                fname: personalInfo.fname,
                lname: personalInfo.lname,
                email: personalInfo.email,
                mobile: personalInfo.mobile,
                dob: personalInfo.dob,
                address: address,
                selfie: personalInfo.selfie
            }

            store.dispatch(setPersonalInfo(personalInfo1));

            var shopDetails = {
                shopPic: this.state.shopImageUrl,
                address: address,
                name: this.state.shopName,
                email: personalInfo.email,
                mobile: personalInfo.mobile,
                type: this.state.businessType
            }
            var request = {
                header: header,
                personalInfo: personalInfo1,
                shopDetails: shopDetails,
                accountInfo: null,
                kycInfo: this.props.saveDataVal.kycInfo,
                sessionId: this.props.registerRetailerResponse.sessionId,
            }
            const headers = {
                'Authorization': 'Bearer ' + this.props.token,
                'client-id': this.props.agentInfo.id,
                'role': this.props.clientRole
            }

            console.log('save data req:' + JSON.stringify(request));

            httpClient.post(saveDataUrl, request,
                { headers }
            ).then((response) => {
                console.log('save data response' + JSON.stringify(response.data));
                if (response.data.response.success == true) {
                    var saveData = {
                        personalInfo: personalInfo1,
                        shopDetails: shopDetails,
                        accountInfo: null,
                        kycInfo: this.props.saveDataVal.kycInfo,
                        sessionId: this.props.registerRetailerResponse.sessionId,
                    }

                    store.dispatch(setSaveData(saveData));

                    //call finalize
                    this.finalize();

                } else {

                    this.setState({
                        progress: 'completed',
                        saveDataErr: 'Something went wrong'
                    })
                }
            }).catch(error => {

                this.setState({
                    progress: 'completed',
                    saveDataErr: 'Something went wrong'
                })
          

            });
        } else {

        }

    }

    finalize = () => {
        var finalizeUrl = '/api/v1/retailer/onboard/session/finalize';
        var header = {
            msgType: "CREATE_ORDER",
            service: "KYC",
            src: "register-retailer",
            dst: "register-retailer",
            channel: "API",
            requesterId: this.props.clientRequesterId,
            requestId: uuidv4(),
            traceId: uuidv4(),
        }
        var request = {
            header: header,
            password: '',
            sessionId: this.props.registerRetailerResponse.sessionId,
        }
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }
        httpClient.post(finalizeUrl, request,
            { headers }
        ).then((response) => {
            console.log('finalize response' + JSON.stringify(response.data));
            if (response.data.response.success == true) {
                store.dispatch(setROResponse(response.data));
                store.dispatch(setROId(response.data.retailerId));
                this.assignAgentToRoId(response.data.retailerId);
            } else {

                this.setState({
                    progress: 'completed',
                    saveDataErr: 'Something went wrong'
                })
                //temp

                // store.dispatch(setROResponse(response.data));
                // store.dispatch(setROId(response.data.retailerId));
                // this.assignAgentToRoId(response.data.retailerId);
            }
        }).catch(error => {

            this.setState({
                progress: 'completed',
                saveDataErr: 'Something went wrong'
            })
  

        });
    }
    backToUploadId = () => {
        var backToUploadIdBtn = document.getElementById('backToUploadIdBtn');
        backToUploadIdBtn.click();
    }

    assignAgentToRoId = (retailerId) => {
        this.setState({
            kycProcessErr: ''
        })
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id
        };

        httpClient.post('/api/v1/emitra/user/' + this.props.agentInfo.id + '/assign/' + retailerId + '/SYS_REGISTERED'
            , '', { headers }
        ).then((response) => {
            console.log('assign Agent to Ro id response' + JSON.stringify(response.data));
            if (response.data.response.success == true) {
                store.dispatch(setROId(response.data.retailerId));

                this.setState({
                    progress: 'completed'
                })

                var gotoKycDetailsBtn = document.getElementById('gotoKycDetailsBtn');
                gotoKycDetailsBtn.click();
            } else {
                this.setState({
                    progress: 'completed',
                    saveDataErr: 'Something went wrong'
                })

                //temp
                this.setState({
                    progress: 'completed'
                })

                // var gotoKycDetailsBtn = document.getElementById('gotoKycDetailsBtn');
                // gotoKycDetailsBtn.click();

            }
        }).catch(error => {
            this.setState({
                progress: 'completed',
                saveDataErr: 'Something went wrong'
            })
         

        });
    }


    render() {


        return (
            <div>
                <HeaderCommon />
                <Menu />
                <div class="mid-contant1">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="head1">
                                    <h2>Shop/Business Details</h2>
                                </div>
                                <Link to='/kyc-details'>
                                    <button id='gotoKycDetailsBtn' hidden={true}></button>
                                </Link>
                            </div>

                            <div class="col-12">
                                <div class="registerbox">
                                    <div class="row mb-3">
                                        <div class="col-12 col-lg-7">
                                            <form onSubmit={this.saveAndFinalize}>
                                                <div class="row">
                                                    <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            <input type="text" class="form-control" id="name" placeholder="Enter shop name" value={this.state.shopName}
                                                                onChange={this.enterShopName}
                                                                required />
                                                            <label for="nmae">Shop/Business name</label>
                                                        </div>
                                                    </div>
                                                    {this.state.businessTypeOnLoad != '' &&
                                                        <div class="col-12 col-sm-6">
                                                            <div class="form-floating">
                                                                <input type="text" class="form-control" id="type" value={this.state.businessTypeOnLoad}
                                                                    onChange={this.showBusinessTypeSection} />
                                                                <label for="type">Business Type</label>
                                                            </div>
                                                        </div>
                                                    }
                                                    {this.state.businessTypeOnLoad == '' &&
                                                        <div class="col-12 col-sm-6">
                                                            <div class="form-floating">
                                                                <select class="form-select" id="type" aria-label=""
                                                                    onChange={this.typeSelect} required>
                                                                    {this.state.businesstypes.map(type => (
                                                                        <option value={type.value}
                                                                        >{type.label}</option>
                                                                    ))}
                                                                </select>
                                                                <label for="type">Business Type</label>
                                                                {this.state.businessTypeErrMsg != '' &&
                                                                    <div class='valid-error'>
                                                                        {this.state.businessTypeErrMsg}
                                                                    </div>}
                                                            </div>
                                                        </div>
                                                    }

                                                    {this.state.addressTypeOnLoad != '' &&
                                                        <div class="col-12 col-sm-6">
                                                            <div class="form-floating">
                                                                <input type="text" class="form-control" id="type" value={this.state.addressTypeOnLoad}
                                                                    onChange={this.showAddressTypeSection} />
                                                                <label for="type">Address Type</label>
                                                            </div>
                                                        </div>
                                                    }
                                                    {this.state.addressTypeOnLoad == '' &&
                                                        <div class="col-12 col-sm-6">
                                                            <div class="form-floating">

                                                                <select class="form-select" id="type" aria-label=""
                                                                    onChange={this.addressTypeSelect} required>
                                                                    {this.state.addressTypes.map(address => (
                                                                        <option value={address.value}
                                                                        >{address.label}</option>
                                                                    ))}
                                                                </select>
                                                                <label for="type">Address Type</label>
                                                                {this.state.addressTypeErrMsg != '' &&
                                                                    <div class='valid-error'>
                                                                        {this.state.addressTypeErrMsg}
                                                                    </div>}
                                                            </div>
                                                        </div>
                                                    }

                                                    <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            <input type="text" class="form-control" id="add1" placeholder="Enter Address" value={this.state.address}
                                                                onChange={this.enterAddress}
                                                                required />
                                                            <label for="add1">Address line 1</label>
                                                        </div>
                                                    </div>

                                                    <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            <input type="text" class="form-control" id="add2" placeholder="Enter Address" value={this.state.address2}
                                                                onChange={this.enterAddress2} />
                                                            <label for="add2">Address line 2</label>
                                                        </div>
                                                    </div>
                                                    {this.state.stateOnLoad != '' &&
                                                        <div class="col-12 col-sm-6">
                                                            <div class="form-floating">
                                                                <input type="text" class="form-control" id="states" value={this.state.stateOnLoad}
                                                                    onChange={this.showStateSection} />
                                                                <label for="states">States</label>
                                                            </div>
                                                        </div>
                                                    }
                                                    {this.state.stateOnLoad == '' &&
                                                        <div class="col-12 col-md-6">
                                                            <div class="form-floating">
                                                                <select class="form-select" id="states" aria-label=""
                                                                    onChange={this.stateSelect} required>
                                                                    {this.state.states.map(state => (
                                                                        <option value={state.value}
                                                                        >{state.label}</option>
                                                                    ))}
                                                                </select>
                                                                <label for="state">Select States</label>
                                                                {this.state.stateErrMsg != '' &&
                                                                    <div class='valid-error'>
                                                                        {this.state.stateErrMsg}
                                                                    </div>}
                                                            </div>
                                                        </div>
                                                    }

                                                    <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            <input type="text" class="form-control" id="city" placeholder="Enter City" value={this.state.city}
                                                                onChange={this.enterCity}
                                                                required />
                                                            <label for="city">City name</label>
                                                        </div>
                                                    </div>


                                                    <div class="col-12 col-md-6">
                                                        <div class="form-floating">
                                                            <input type="number" class="form-control" id="pincode" placeholder="Enter pincode" value={this.state.pinCode}
                                                                onInput={(e) => e.target.value = e.target.value.slice(0, 6)}
                                                                onChange={this.enterPinCode}
                                                                required />
                                                            <label for="pincode">Pincode</label>
                                                            {this.state.pinCodeErr != '' &&
                                                                <div class='valid-error'>
                                                                    {this.state.pinCodeErr}
                                                                </div>}
                                                        </div>
                                                    </div>

                                                    <div class="col-12 col-md-6">
                                                        <div class="file-upload">
                                                            <div class="dropzone-wrapper">
                                                                <div class="dropzone-desc">
                                                                    <i class="camera"></i>
                                                                    <h6>Upload Shop Photo</h6>
                                                                </div>
                                                                <div id="drop_zone" onDrop={this.dropHandler} onDrag={this.dragOverHandler}>
                                                                </div>
                                                                <input type="file" name="fileup" class="dropzone"
                                                                    onChange={e => this.uploadDoc(e, 'shopImage')} />
                                                            </div>
                                                            {this.state.shopImageUrl != '' &&
                                                                <img src={this.state.shopImageUrl} alt="Oxigen" class="img-fluid" />
                                                            }
                                                            {this.state.shopImageUploadMsg != '' &&
                                                                <div class="valid-success">
                                                                    {this.state.shopImageUploadMsg}
                                                                </div>}
                                                            {this.state.shopImageUploaErrdMsg != '' &&
                                                                <div class="valid-error">
                                                                    {this.state.shopImageUploaErrdMsg}
                                                                </div>}
                                                        </div>


                                                    </div>

                                                    <div class="col-12">
                                                        <button type="submit" class="btn btn-primary" id="proceed"
                                                            disabled={this.state.progress == 'loading' && true}
                                                        >Proceed</button>
                                                    </div>
                                                    {this.state.saveDataErr != '' &&
                                                        <div class='valid-error'>
                                                            {this.state.saveDataErr}
                                                        </div>
                                                    }
                                                </div>
                                            </form>
                                        </div>

                                        <div class="col-12 col-lg-5 d-none d-lg-block">
                                            <div class="topbtn">
                                                <a onClick={this.backToUploadId}>Back</a>
                                            </div>
                                            <Link to='/upload-retailer'>
                                                <button id='backToUploadIdBtn' hidden={true}></button>
                                            </Link>
                                            <div class="rightbanner"><img src="images/shop-img.png" alt="Oxigen" class="img-fluid" /></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { phone, agentInfo, token, clientRole, deviceInfo, clientRequesterId },
        retailerKycReduce: { registerRetailerResponse, personalInfo, saveDataVal } }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, phone, agentInfo, token, clientRole, deviceInfo, clientRequesterId, registerRetailerResponse, personalInfo, saveDataVal
});

export default connect(mapStateToProps, null)(AddBusinessDetails);
